import styled from "styled-components";

export const StyledDatePickerWithPrettyLittleRoundedCorners = styled.div`
  .ant-calendar-picker > div > input {
    border-radius: 4px;
  }
`;
